import { call, put, takeLatest } from 'redux-saga/effects';

import * as twitterActions from './twitterActions.js';
import { updateTwitterApiCall } from './twitterAPI.js';

function* updateTwitterSaga({ payload }) {
  try {
    const { data } = yield call(updateTwitterApiCall, payload);
    yield put(twitterActions.twitterUpdateStore(data));
  } catch (error) {
    yield put(twitterActions.twitterUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* twitterWatcher() {
  yield takeLatest(twitterActions.twitterUpdateRequest.type, updateTwitterSaga);
}
